import { Card } from '@sumup/circuit-ui';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  margin-bottom: 1rem;
`;
